import { createRoot } from 'react-dom/client';

// pre-register iconify icons at build time (avoid CDN fetching at runtime)
import './utils/iconifyOffline';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'


// project imports
// import * as serviceWorker from 'serviceWorker';
import App from './App';
import { store } from './store/index';

// style + assets
import './assets/scss/style.scss';

// ==============================|| REACT DOM RENDER  ||============================== //

let persistor = persistStore(store);


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter >
            <App />
        </BrowserRouter>
        </PersistGate>
    </Provider>
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
